'use server'

import { signIn } from '../../../auth'
import { AuthError } from 'next-auth'
import { headers } from 'next/headers'
import { checkRateLimit, resetRateLimit } from '@/lib/rate-limit'

export async function loginAction(formData: FormData) {
  const headerStore = await headers()
  const ip = headerStore.get('x-forwarded-for')?.split(',')[0].trim()
    ?? headerStore.get('x-real-ip')
    ?? 'unknown'

  const rl = checkRateLimit(ip)
  if (!rl.allowed) {
    return { error: `Too many attempts. Try again in ${rl.retryAfterSeconds} seconds.` }
  }

  try {
    await signIn('credentials', {
      email: formData.get('email') as string,
      password: formData.get('password') as string,
      redirectTo: '/radovi/dashboard',
    })
    // signIn succeeds only if it doesn't throw — clear the counter on success
    resetRateLimit(ip)
  } catch (e) {
    if (e instanceof AuthError) {
      return { error: 'Invalid email or password.' }
    }
    // signIn throws a redirect — re-throw so Next.js can handle it
    throw e
  }
}
